import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenderPreview } from 'src/models/procurements/Preview/hooks';
import styles from './index.module.scss';
import TenderPreviewMatchesTotal from './MatchesTotal';
import TenderPreviewMatchesItem from './MatchesItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from 'src/common';
import classNames from 'classnames';
import { InfoBox } from 'src/shared';
import { Translations } from 'src/lib/I18nService/types';

export const TenderPreviewMatches: FC = () => {
  const { t } = useTranslation();
  const { t: cpvT } = useTranslation(Translations.cpvCodes);
  const { data } = useTenderPreview();
  const highlights = data?.highlights;
  const matchedCpvs = data?.matchedCpvs;

  return !!highlights?.length || !!matchedCpvs?.length ? (
    <>
      <TenderPreviewMatchesTotal highlights={highlights} cpvCodes={matchedCpvs} />
      {!!highlights?.length && (
        <>
          {highlights?.map(keyword => (
            <div className={styles.keyword} key={keyword.keyword}>
              <div className={styles.header}>
                <h4 className={styles.title}>
                  {!!keyword.keyword ? (
                    keyword.keyword
                  ) : (
                    <Tooltip title={t('Tenders.unrecognisedSectionTooltip')}>
                      {t('Tenders.unrecognisedSection')}
                      <FontAwesomeIcon icon={faInfoCircle} className={styles.unrecognisedIcon} />
                    </Tooltip>
                  )}
                </h4>
              </div>
              {keyword.highlights.map((highlight, index) => (
                <TenderPreviewMatchesItem highlight={highlight} key={`highlight_${index}`} />
              ))}
            </div>
          ))}
        </>
      )}
      {!!matchedCpvs?.length && (
        <>
          <h4 className={classNames(styles.header, styles.title)}> {t('Tenders.cpvCodes')}</h4>
          <div className={styles.boxes}>
            {matchedCpvs?.map(cpvCode => (
              <InfoBox
                key={cpvCode}
                className={styles.match}
                title={cpvCode.split('-')[0]}
                value={cpvT(cpvCode.split('-')[0])}
              />
            ))}
          </div>
        </>
      )}
    </>
  ) : (
    <span className={styles.desc}>{t('Tenders.matchesEmpty')}</span>
  );
};

export default TenderPreviewMatches;
